module.exports = __webpack_public_path__ + "static/media/santiago_castro.7288c0ab.jpg";